import React from "react";
import { ButtonV2 } from "@Modules/common/ButtonV2";
import { classNames } from "repoV2/utils/common/render/classNames";
import { INoSlotsAvailableProps } from "./NoSlotsAvailable";
import styles from "./noSlots.module.scss";
import useNoSlotsAvailable from "./useNoSlotsAvailable";

const NoSlotsAvailable = (props: INoSlotsAvailableProps): JSX.Element => {
    const { showCta, ctaText, onCtaCLick, pre, post } =
        useNoSlotsAvailable(props);

    return (
        <div className={styles.sectionBody}>
            {pre}
            &nbsp;
            {showCta && (
                <ButtonV2
                    applyTheme
                    design="plain"
                    onClick={onCtaCLick}
                    className={classNames(styles.getInTouchLink, "p-0")}
                >
                    {ctaText}
                </ButtonV2>
            )}
            &nbsp;
            {post}
        </div>
    );
};

export default NoSlotsAvailable;
